import './website.less'

import type { PluginObject } from 'vue'

import { UiInputNumber } from '@omnica/input-number-vue2'
import { UiLoader } from '@omnica/loader-vue2'
import { UiScrollbar } from '@omnica/scrollbar-vue2'

import { OmnicaPopperPlugin } from '@omnica/popper-vue2'
import { OmnicaTooltipPlugin } from '@omnica/tooltip-vue2'

export const OmnicaPlugin: PluginObject<never> = {
  install (Vue) {
    Vue.component('UiInputNumber', UiInputNumber)
    Vue.component('UiLoader', UiLoader)
    Vue.component('UiScrollbar', UiScrollbar)

    Vue.use(OmnicaPopperPlugin)
    Vue.use(OmnicaTooltipPlugin)
  }
}
